'use client'
import {
  CurrencyConfig
} from "./chunk-437XYJZA.mjs";
import {
  CURRENCY_EXCHANGE_CACHE
} from "./chunk-XYTTLPTA.mjs";
import {
  __async
} from "./chunk-QB4ZOYYY.mjs";

// src/api/exchange.ts
import { useCallback, useEffect, useState } from "react";
import { Exception } from "@wbk/logger";
var getCurrencyExchange = (_0) => __async(void 0, [_0], function* ({ currency }) {
  var _a, _b;
  try {
    const baseApi = (_b = (_a = CurrencyConfig) == null ? void 0 : _a.config) == null ? void 0 : _b.exchangeApi;
    if (!baseApi) {
      throw new Error("CurrencyConfig Excahnge API is not configured");
    }
    if (CURRENCY_EXCHANGE_CACHE.has(currency)) {
      return CURRENCY_EXCHANGE_CACHE.get(currency);
    }
    const res = yield fetch(`${baseApi}/${currency}.json`);
    const json = yield res.json();
    const data = json == null ? void 0 : json[currency];
    CURRENCY_EXCHANGE_CACHE.set(currency, data);
    return data;
  } catch (error) {
    throw new Exception({
      error,
      name: "getCurrencyExchangeException"
    });
  }
});
var useGetCurrencyExchange = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();
  const [data, setData] = useState();
  const fetchData = useCallback(() => __async(void 0, null, function* () {
    if (!(props == null ? void 0 : props.currency)) {
      return;
    }
    setIsLoading(true);
    try {
      const result = yield getCurrencyExchange(props);
      setData(result);
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  }), [props == null ? void 0 : props.currency]);
  useEffect(() => {
    fetchData();
  }, [fetchData]);
  return { isLoading, error, data };
};

export {
  getCurrencyExchange,
  useGetCurrencyExchange
};
//# sourceMappingURL=chunk-RFT2B4D6.mjs.map